import { OptionsTranslations } from "./optionsTranslations.types";
import {
    getCgvLink,
    getDataRightsLink,
    getPrivacyPolicyLink,
} from "@/service/legalLinks/legalLinksService";

const cgvUrl = getCgvLink();
const dataRightsLink = getDataRightsLink("fr");
const privacyPolicyLink = getPrivacyPolicyLink("fr");

export const optionsFrTranslations: OptionsTranslations = {
    optionsPage: {
        "title": "Extras",
        "step": "ÉTAPE",
        "optionsExtraTitle": "Personnalisez votre voyage",
        invalidLastNameError: 'Veuillez entrer un nom de famille valide, au moins 2 caractères',
        optionsChangeModalErrorAgeChange: "En raison des changements d'âge de l'un des participants, les prix et la disponibilité de certaines options ont changé.",
        optionsChangeModalContinue: "Continuer",
        invalidDateError: 'Veuillez entrer votre date de naissance',
        invalidFirstNameError: 'Veuillez entrer un prénom valide, au moins 2 caractères',
        hasFirstParticipantToBeAdultError: 'Le premier participant doit être majeur',
        hasToBeAdultError: 'Le participant doit être majeur',
        accommodationExceedsAdultsError: 'Le nombre d\'hébergements sélectionnés ne peut pas dépasser le nombre d\'adultes dans votre groupe. Veuillez modifier les dates de naissance des participants.',
        accommodationCount: 'Nombre d\'hébergements',
        adultCount: 'Nombre d\'adultes',
        invalidParticipantError: "Veuillez remplir les informations de ce participant",
        optionsModify: "Personnaliser",
        optionsModifyPanel: "Modifier",
        optionsPanelTitleModify: "Modifiez les",
        optionsPanelTitleModifyLa: "Modifiez la",
        optionsPanelTitleModifyFor1: "Modifiez le",
        optionsPanelTitleModifyFor2: "de",
        optionsAdd: "Ajouter",
        optionsIncluded: "Inclus",
        optionsDay: "jour",
        optionsDays: "jours",
        optionsDays2: "journées",
        optionsFrom: "du",
        optionsTo: "au",
        optionsValidateSelection: "Validez votre sélection",
        validateForAllParticipants: "Validez votre sélection pour tous les participants",
        optionsRemoved: "retiré du package",
        optionsErrorSorry: "Désolé,",
        optionsErrorDefaultService: "ce service",
        optionsErrorNotAvailable: "n’est plus disponible.",
        optionsNoServiceSelected: "Aucun service sélectionné",
        optionsNoServiceSelected1: "Aucun",
        optionsNoServiceSelected2: "sélectionné",
        optionsNoSkipass: "Aucun skipass sélectionné",
        optionsNoEquipment: "Aucun matériel de ski sélectionné",
        optionsNoTransport: "Aucun transport sélectionné",
        optionsNoEsf: "Ancun cours de ski sélectionné",
        optionsVirtualNoEsf: "Aucun cours de ski",
        optionsEsfOneLesson: "1 cours de ski sélectionné",
        optionsEsfLessonsCount: "{count} cours de ski sélectionnés",
        optionsEsfLoading: "Chargement des cours de ski…",
        optionsEsfConfigured: "Cours configuré",
        optionsEsfProgress: "{done}/{total} cours configurés",
        optionsEsfPanelTitle: "Cours de ski ESF",
        optionsEsfParticipantIncomplete: "Complétez le profil du participant",
        optionsEsfAlreadyConfigured: "Ce participant a déjà un cours configuré.",
        optionsEsfModify: "Modifier",
        optionsEsfRemove: "Supprimer",
        optionsEsfRemoveFailed: "Impossible de supprimer le cours.",
        optionsNoFood: "Aucun panier repas sélectionné",
        optionsNoInsuranceSkier: "Aucune assurance skieur sélectionnée",
        optionsNoHotelService: "Aucun service hôtelier sélectionné",
        options15Cancellation: "Inclus : Annulation gratuite  jusqu’à 15 jours avant le séjour",
        options45Cancellation: "Annulation gratuite de 100% du séjour jusqu’à J-40*",
        options45CancellationUnderSentence: "*Pour en savoir plus, consultez nos CGV",
        optionsWhoDeparts: "Participants",
        optionsPleaseFillParticipants: "Veuillez renseigner les noms, prénoms et âges de chaque participant au début du séjour.",
        widgetAllParticipantsRequired: "Veuillez enregistrer tous les participants (bouton Enregistrer sur chaque fiche) avant de continuer.",
        widgetContactInvalid: "Veuillez saisir une adresse e-mail et un numéro de téléphone valides.",
        widgetRegisterFailed: "Impossible de créer le compte avec ces coordonnées. Réessayez ou utilisez une autre adresse e-mail.",
        widgetTransportConfigureTitle: "Paramétrez votre transport",
        widgetJourneyDetailsTitle: "Détails du voyage",
        widgetOrderRecapTitle: "Recap de la commande",
        widgetTrainOutboundColumn: "Train aller",
        widgetTrainReturnColumn: "Train retour",
        widgetNoReturnTrain: "—",
        widgetTransferToStation: "Transfert vers {station}",
        widgetTransferFromStation: "Transfert depuis {station}",
        optionsFillNames: "Veuillez renseigner les noms, prénoms et âges de chaque participant pour profiter des meilleurs tarifs.",
        optionsParticipant: "Participant",
        optionsYears: "ans",
        optionsYearsAndMore: "et plus",
        optionsAgeAtStart: "Age du participant le jour du voyage",
        optionsFirstName: "Prénom",
        optionsLastName: "Nom",
        optionsTravelersErrorMessage: "Veuillez renseigner les noms, prénoms et âges de chaque participant",
        optionsPrepareYourVoyage: "Personnalisez votre séjour",
        optionsSelectYourInsurances: "Sélectionnez vos assurances",
        optionsChangeTravelerAge: "Modifier l’âge du participant remettra à zéro toutes ses options.",
        optionsChangeTravelerAgeConfirmation: "L’âge des participants suivants a été mis à jour, toutes leurs options ont été remises à zéro",
        optionsChangeTravelerAgeUpdated: "Les informations des participants ont été mises à jour",
        optionsIUnderstood: "J’ai compris",
        optionsSkipass: "Skipass",
        optionsNoSkipassSelected: "Pas de skipass sélectionné",
        optionsKmSkiSlopes: "km de pistes",
        optionsOfTracks: "de pistes",
        optionsRemoveSkipass1: "Si vous retirez cette option de votre package, un montant de",
        optionsRemoveSkipass2: "sera conservé",
        optionsNoQueues: "Réservez vos forfaits et récupérez-les lors de la remise des clés",
        optionsSkipassBlueSentence: "Économisez du temps et de l’argent",
        optionsEquipment: "Matériel de ski",
        optionsSelectLevel: "Sélectionnez la gamme de matériel",
        criteria997: "Économique",
        criteria998: "Argent",
        criteria999: "Or",
        criteria1000: "Platine",
        criteria1031: "Espoir",
        criteria1030: "Champion",
        optionsNoEquipmentSelected: "Pas de matériel de ski sélectionné",
        optionsEnjoySkiingAtArrival1: "Retirez votre matériel au magasin",
        optionsEnjoySkiingAtArrival2: "situé à",
        optionsEnjoySkiingAtArrival3: "mètres de votre hébergement !",
        optionsHelmet: "Casque",
        optionsShoes: "Chaussures",
        optionsSticks: "Bâtons",
        optionsEquipmentBlueSentence: "Gagnez en proximité et sérénité",
        optionsTransport: "Transport",
        optionsTransfer: "Transfert",
        optionsEnjoySkiingAtArrival: "Profitez du ski dès votre arrivée !",
        optionsDistanceFromSkiShop1: "La boutique",
        optionsDistanceFromSkiShop2: "se situe à",
        optionsDistanceFromSkiShop3: "de votre hébergement !",
        optionsDistanceFromSkiShop4: "se situe dans le même bâtiment que votre hébergement !",
        optionsPickupEquipmentAtShop: "Récupérez votre matériel dans la boutique",
        optionsAddTransport: "Ajouter un transport",
        optionsAddTransportFor: "Ajouter un transport pour",
        optionsDeleteTransport: "Supprimer le transport",
        optionsTransportFirstDate: "Aller",
        optionsTransportSecondDate: "Retour",
        optionsPackageTravelski: "Package Travelski :",
        optionsTrainPlusShuttle: "train + navette. Souciez-vous uniquement de vos vacances au ski en famille !",
        optionsNoTransportSelected: "Pas de transport sélectionné",
        optionsChooseAGo: "Choisissez votre aller",
        optionsChooseAReturn: "Choisissez votre retour",
        optionsDeparture: "Départ",
        optionsReturn: "Retour",
        optionsDepartureStation: "Gare de départ",
        optionsArrivalStation: "Gare d’arrivée",
        optionsOneWayOption: "Options",
        optionsITravelIn: "Je voyage en :",
        optionsMyTransfer: "Mon transfert",
        optionsTransportSummaryFor: "Récapitulatif du transport pour",
        optionsTotalTransport: "Total du transport",
        optionsTransitTime: "de correspondance",
        optionsEstimatedTime: "Estimé à",
        optionsInformation: "Informations",
        train: "tarin",
        criteria1039: "1ère classe",
        criteria1040: "2nde classe",
        shuttle: "Navette",
        taxi: "Taxi",
        baggageCabin: "Bagage cabine",
        backpack: "Sac à dos",
        wifi: "Wifi",
        meal: "Repas",
        dinner: "Dîner",
        optionsHowToChooseTitle: "Comment choisir un cours adapté à mon niveau de ski ?",
        optionsSkiLesson: "Cours de ski",
        optionsTakeEsf: "Sélectionnez un cours",
        optionsCourseOn: "Cours sur",
        optionsHowIChooseLesson: "Choisissez un cours collectif adapté à votre niveau du ski",
        optionsBeginner: "Débutant",
        optionsPiouPiou: "Piou-Piou",
        criteria992: "Ourson",
        criteria993: "Flocon",
        criteria994: "1ère étoile",
        criteria995: "2ème étoile",
        criteria996: "3ème étoile",
        criteria1058: "Niv. 0",
        criteria1059: "Niv. 1",
        criteria1060: "Niv. 2",
        criteria1061: "Niv. 3",
        criteria1062: "Niv. 4",
        criteria1063: "Niv. 5",
        criteria1064: "Ski",
        criteria1065: "Snowboard",
        optionsSkiTab: "Ski",
        optionsSnowboardTab: "Snowboard",
        optionsNoCourseSelected: "Pas de cours sélectionné",
        optionsContentPiouPiou: "Je veux goûter aux plaisirs de la neige et tenter mes premières glissades à skis.",
        optionsContentOursonTitle: "Je n’ai jamais skié",
        optionsContentOurson: "Je veux faire mes 1ères descentes à ski en chasse neige et apprendre à faire des virages.",
        optionsContentFloconTitle: "J’ai eu mon Ourson",
        optionsContentFlocon: "J’ai envie d’aller sur les pistes et faire de grands virages plus vite.",
        optionsContent1StarTitle: "J’ai eu mon flocon",
        optionsContent1Star: "Je tourne en chasse-neige et je prends le téléski tout seul.",
        optionsContent2StarTitle: "J’ai réussi ma première étoile. Je skie un peu partout sur les pistes faciles.",
        optionsContent2Star: "J’aimerai apprendre à déraper et à tourner les skis presque parallèles pour aller sur les grandes pistes.",
        optionsContent3StarTitle: "J’ai obtenu ma 2ème étoile",
        optionsContent3Star: "Je dois perfectionner mon virage parallèle et mes dérapages pour être super à l’aise tout en allant plus vite.",
        optionsContentAdulteBeginnerTitle: "Je ne sais pas skier",
        optionsContentAdulteBeginner: "Je souhaite apprendre à garder l’équilibre, contrôler ma vitesse, faire des virages en chasse-neige et utiliser les remontées mécaniques.",
        optionsAdultsBeginner: "Adultes - ski débutant",
        optionsWatchVideo: "Voir la vidéo",
        optionsBackToChoices: "Revenez aux choix du participant",
        optionsAgeGroup1: "3 à 4 ans",
        optionsAgeGroup2: "4 à 5 ans",
        optionsAgeGroup3: "6 à 12 ans",
        optionsAgeGroup4: "13 ans et plus (Adultes)",
        optionsFood: "Panier repas",
        optionsTakeFood: "Sélectionnez un panier repas",
        optionsTakeFoodFor: "Sélectionnez un panier repas pour",
        optionsCatering: "Déjeuner restaurant La Folie Douce",
        optionsCateringDelivery: "Vos paniers de courses livrés le jour de votre arrivée",
        optionsNoFoodSelected: "Pas de panier repas sélectionné",
        optionsSeeMenu: "Voir le menu",
        optionsRestaurant: "Restauration",
        optionsCateringServices: "Des services de restauration adaptés à vos envies",
        optionsRestaurationBord: "Restauration à bord",
        optionsRestaurationBordOutbound: "Restauration à bord - Aller",
        optionsRestaurationBordInbound: "Restauration à bord - Retour",
        optionsFacilitateArrival: "Faciliter votre arrivée en réservant vos services",
        optionsReserveYourServices: "Réservez vos services",
        optionsTakeAccommodationServices: "Sélectionnez vos services hôteliers",
        optionsBookServices: "Réservez vos services",
        optionsBookServicesEasy: "Facilitez votre arrivée en réservant vos services",
        optionsInsurance: "Assurance",
        optionsTakeInsurance: "Souscrivez à l’assurance skieur",
        optionsNoInsuranceSelected: "Pas d’assurance sélectionnée",
        optionsInsuranceAdvantages: "Les avantages de l’assurance skieur",
        optionsPerPers: "pers",
        optionsBreakageTheft: "Bris & vols du matériel de ski personnel ou de location",
        optionsRescueResearch: "Frais de secours et recherche sur les pistes",
        optionsHospitalization: "Frais médicaux et d’hospitalisation (hors sécurité sociale)",
        optionsRepatriation: "Frais de rapatriement",
        optionsInterruptionStay: "Frais d’interruption de séjour et de remboursement des prestations non utilisées",
        optionsSnowGuarantee: "Garantie neige",
        optionsInsuranceAnnulation: "Assurance annulation de séjour",
        optionsPerBooking: "dossier",
        optionsCancellation: "Annulation possible jusqu’à la veille du départ",
        optionsReimbursement: "Remboursement en chèque ou virement en cas de motif justifié",
        optionsCreditNote: "Couvre les cas exclus par les cartes bancaires",
        optionsCoveragePrice: "Bon d’achat valable 12 mois en cas de motif non justifié",
        optionsInsuranceAnnulationNo: "Je ne souscris pas l’assurance",
        optionsInsuranceAnnulationYes: "Je souscris l’assurance",
        optionsInsuranceSlogan: "Soyez couverts pendant votre séjour",
        optionsPerson: "adulte",
        optionsFree: "Gratuit",
        commercialDiscount: "Remise commerciale",
        moreInfos: "Plus d’infos",
        seeLess: "Fermer",
        saveRegistration: "Enregistrer",
        acceptConditions: "J'ai lu et j'accepte les Conditions générales de vente et la Politique de gestion des données personnelles.",
        optionSumbit: "Réserver",
        yes: "Oui",
        no: "Non",
        optionsInsuranceAnnulationCallToAction: "Voulez-vous souscrire à l’assurance annulation ?",
        optionsSkiSchool: 'Ecole de ski',
        optionsChangeModalTitle: "Modifications des options",
        optionsChangeModalDescription: "En raison des changements d'âge de l'un des participants, les prix et la disponibilité de certaines options ont changé. Voici les modifications.",
        optionsChangeModalSubtitle: "Options modifiées en raison des changements d'âge",
        optionsChangeModalTotalDifference: "Différence totale :",
        optionsChangeModalDismiss: "Fermer",
        optionsChangeModalNoChange: "Aucun changement",
        optionsChangeModalNotAvailable: "Non disponible",
        optionsChangeModalOption: "Option",
        optionsChangeModalChangesAgeFrom: "change l'âge de",
        optionsChangeModalTo: "à",
        optionsChangeModalTraveller: "Voyageur",
        optionsSkiInsurance: 'Assurance Skieur',
        enterPromocode: "Ajouter un code promo*",
        promocode: "Code Promo",
        promocodeWrong: "Le code promotionnel que vous avez indiqué n'est pas valide",
        promocodeApplied: "Code promotionnel appliqué avec succès",
        promocodeEmailRequired: "L'email est requis pour utiliser ce code promotionnel",
        promocodeEmailModalTitle: "Entrez votre email",
        promocodeEmailPlaceholder: "Votre adresse email",
        promocodeEmailSubmit: "Valider",
        promocodeEmailCancel: "Annuler",
        promocodeEmailInvalid: "Format d'email invalide",
        promocodeRemoved: "Votre code promotionnel a été supprimé",
        promocodeExternalValidationTitle: "Validation externe requise",
        promocodeExternalValidationProvider: "Fournisseur",
        promocodeExternalValidationCancel: "Annuler",
        promocodeExternalValidationSubmit: "Valider",
        promocodeExternalValidationFieldFirstname: "Prénom",
        promocodeExternalValidationFieldLastname: "Nom de famille",
        promocodeExternalValidationFieldBirthdate: "Date de naissance",
        promocodeExternalValidationFieldLastSixDigits: "6 derniers chiffres",
        promocodeExternalValidationFieldRequired: "{{label}} est requis",
        promocodeExternalValidationFieldInvalidFormat: "Le format de {{label}} est invalide",
        promocodePrivateWarningTitle: "ATTENTION : Ce code promo est privé",
        promocodeDeleteCode: "Je supprime mon code",
        promocodeValidate: "Je valide",
        promocodePrivateWarningProof: "Attention, un **justificatif d'appartenance** à [CSE NAME] pourrait vous être demandé à votre arrivée.",
        promocodeWarningTitle: "Attention",
        removePromocode: "Supprimer le code",
        optionFlightLuggage: "Bagage",
        optionsFlightLuggageHoldBag: "Bagage supplémentaire",
        optionsFlightLuggageUnderSeatBag: "Bagage sous-siège",
        optionsFlightAdditionalLuggage: "Bagage supplémentaire",
        optionsFlightLuggageUnderSeatBagInfo: "Votre réservation inclut un bagage à main.",
        optionsFlightLuggageUnderSeatBagInfoMaxSize: "Taille maximale : 40x30x20 cm",
        optionsLuggagePopupTitle: "Voyagez-vous sans bagage ?",
        optionsLuggagePopupDescription: "Il semble que vous n'ayez ajouté aucun bagage à votre réservation. Pour un forfait vol, cela pourrait être gênant.\n\nSouhaitez-vous continuer sans bagage ou en ajouter maintenant ?",
        optionsLuggagePopupNoLuggage: "Je ne veux pas de bagage",
        optionsLuggagePopupAddLuggage: "Je veux ajouter des bagages",
        optionParking: "Parking",
        optionsParkingDefault: "Place de parking",
        // Transport cabin translations
        transportSharedCabinTitle: "Couchettes individuelles",
        transportSharedCabinDescription: "Vivez une expérience unique en voyage cabine.",
        transportPrivateCabinTitleSingle: "Compartiment privatif 6 places",
        transportPrivateCabinTitlePlural: "Compartiments privatifs 6 places",
        transportPrivateCabinDescription: "Réservez l'intégralité d'un compartiment, seul ou à plusieurs, pour votre voyage en famille ou entre amis.",
        transportDetailBannerDescription: "Nos compartiments sont composés de 6 couchettes pour vous garantir une nuit de repos.",
        transportDetailBannerDetails: "Détails",
        transportDetailSharedCabinDescription: "Chaque compartiment est conçu comme un espace chaleureux, intime et confortable où familles et amis se retrouvent pour partager, échanger et rêver ensemble aux moments qui les attendent.",
        transportDetailSharedCabinFooterTitle: "Voyagez entre femmes",
        transportDetailSharedCabinFooterDescription: "Nous avons prévu un espace 100% féminin pour un voyage en toute quiétude.",
        transportDetailPrivateCabinDescription: "Les compartiments sont privatisables, que ce soit pour les familles, les tribus ou selon des préférences essentielles pour un voyage en toute quiétude.",
        transportCriteriaWifi: "Wi-fi gratuit",
        transportCriteriaBar: "Wagon bar",
        transportCriteriaOutlet: "Prise électrique",
        transportCriteriaPillow: "Drap, sac de couchage, taie d'oreiller et couverture fournis.",
        transportCriteriaComfortPouch: "Pochette confort (lingettes rafraîchissantes, bouchons d'oreilles, mouchoirs)",
        transportCriteriaPrivateSpace: "Espace privé",
        transportCriteriaPlaces: "6 places couchettes",
        transportOnlyWomenTitle: "Espace dame seule (gratuit)",
        transportOnlyWomenDescription: "Un espace réservé aux femmes pour voyager de nuit en toute tranquillité.",
        transportPreferencesAvailabilityNotice: "*Vos préférences seront prises en compte en fonction des disponibilités",
        transportFullTimelineTitle: "Détails du voyage",
        transportDetailPanelTitle: "Un trajet tout confort",
        optionsTrainOnly: "Train",
        // Transfer translations
        unicular: "Funiculaire des Arcs",
        transferBusDescription: "Une navette partagée avec des horaires fixes et des arrêts multiples. Il peut être nécessaire de changer de bus ou de marcher.",
        transferBusLesArcsTitle: "Navette",
        transferBusLesArcsDescription: "Une navette partagée avec des horaires fixes et des arrêts multiples. Il peut être nécessaire de changer de bus ou de marcher.",
        transferTaxiDescription: "Transfert privé avec chauffeur pour votre usage exclusif.",
        transferUnicularDescription: "Rejoignez les Arcs facilement grâce au funiculaire ultramoderne qui relie la gare de Bourg-Saint-Maurice à la station des Arcs 1600 en seulement 7 minutes.",
        transferCriteriaDuration: "Durée estimée du voyage :",
        transferCriteriaWalking: "Il peut être nécessaire de changer de bus en cours de route ou de marcher jusqu`à votre lieu de séjour.",
        transferUnicularCriteriaWalking: "En gare d'arrivée du téléphérique, vous trouverez les navettes à destination des autres stations des Arcs (Arcs 1800, Arcs 1950 et Arcs 2000)",
        transferCriteriaDoorToDoor: "Service porte-à-porte",
        transferAlps2AlpsStandardTaxiTitle: "Taxi standard",
        transferAlps2AlpsStandardTaxiDescription: "Un transfert adapté aux voyageurs seuls ou aux petites familles voyageant sans équipement de ski.",
        transferAlps2AlpsMinivan7Title: "Minivan – 7 places",
        transferAlps2AlpsMinivan7Description: "Un véhicule spacieux, parfait pour les familles et petits groupes voyageant avec bagages et équipement de ski.",
        transferAlps2AlpsMinivan16Title: "Minivan – 16 places",
        transferAlps2AlpsMinivan16Description: "La solution idéale pour voyager ensemble tout en simplifiant l'organisation des grands groupes.",
        transferAlps2AlpsSharedTaxiTitle: "Taxi partagé",
        transferAlps2AlpsSharedTaxiDescription: "Une option économique et écologique pour rejoindre votre station en partageant votre trajet avec d'autres voyageurs.",
        transferAlps2AlpsUpToPassengers: "Jusqu'à {count} passagers",
        transferAlps2AlpsEstimatedTravelTime: "Temps de trajet estimé :",
        transferAlps2AlpsDoorToDoor: "Service porte-à-porte",
    },
    "optin": {
        "common": {
            "seeMore": "Voir plus",
            "seeLess": "Voir moins",
            "clickHere": "cliquer ici",
            "reserve": "Réserver"
        },
        "terms": {
            "label": `J’ai lu et j’accepte les <a href='${cgvUrl}' target='_blank'><strong>Conditions Générales de Vente</strong></a>, les documents d’information et les conditions générales et particulières de vente des assurances et la <a href='${privacyPolicyLink}' target='_blank'><strong>Politique de gestion des données personnelles</strong></a>.`,
            "short": "Les données recueillies sont traitées par la Société Travelfactory qui est le responsable du traitement et dont le siège est situé au 19 rue Emmy Noether, 93400 Saint-Ouen, France. <br/>",
            "full": `Ces données sont indispensables pour gérer votre réservation, et conclure le contrat relatif. Elles seront intégrées dans la base de données de la Société Travelfactory et également utilisées pour vous adresser des informations et des publicités sur des produits et services similaires sur la base notamment de notre intérêt légitime et des dispositions légales en matière de prospection. Vous disposez de droits sur vos données que vous pouvez exercer via notre formulaire de contact disponible <a href='${dataRightsLink}' target='_blank'>ici</a>. Pour en savoir plus sur le traitement de vos données, consultez notre <a href='${privacyPolicyLink}' target='_blank'>politique de protection des données personnelles</a>. Vous pourrez également vous désinscrire à tout moment via un lien dans les newsletters électroniques, ou par courrier électronique.`
        },
        "description": {
            "short": "Si vous ne souhaitez pas recevoir de communication de notre part, <span class='underline'>cliquez ici</span>.",
            "email": "Email",
            "sms": "SMS",
            "note": "Si vous décochez les cases, vous vous opposez à la réception de communication commerciale. Vous restez susceptible de recevoir des communications strictement nécessaires à la réalisation de votre séjour (ex : confirmation de réservation, rappel de votre paiement)."
        }
    },
    "food": {
        "foodImageCriteria1025": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_new.jpg",
        "foodImageCriteria1025Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_mobile_new.jpg",
        "foodImageCriteria10241025": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_halal_new.jpg",
        "foodImageCriteria10241025Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_halal_mobile_new.jpg",
        "foodImageCriteria1023": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_new.jpg",
        "foodImageCriteria1023Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_mobile_new.jpg",
        "foodImageCriteria1024": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal.jpg",
        "foodImageCriteria1024Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal_mobile_new.jpg",
        "foodImageCriteria10231024": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal.jpg",
        "foodImageCriteria10231024Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal_mobile_new.jpg",
        "foodImageCriteria1021": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gastronomique_new.jpg",
        "foodImageCriteria1021Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gastronomique_mobile.jpg",
        "foodImageCriteria1067": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_petit_dejeuner.png",
        "foodImageCriteria1067Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_petit_dejeuner_mobile.png",
        "foodImageCriteria1069": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_demi_pension.png",
        "foodImageCriteria1069Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_demi_pension_mobile.png"
    },
    globalInsuranceConditions: "Voir les conditions de l’assurance"

};


export default optionsFrTranslations;